import React, { FC, useState } from 'react';
import classnames from 'classnames';
import { QuestionState, SenderStatus } from '../../../../constans/question-enums';
import QuestionActionButtons from '../question-action-buttons/question-action-buttons';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import ActionButton from '../../../shared/action-button/action-button';
import { TReviewModeAdditionalAction } from '../questions-review-mode-container/questions-review-mode-container';
import { TUpdateQuestion } from '../../../../store/question-store/question-store';
import { getDate } from '../../../../utils/helpers/date-helper';

import '../question.scss';
import QuestionEntity, { EditableState } from '../../../../store/question-store/question-entetiy';
import { observer } from 'mobx-react';
import MoveHandleIcon from '../../../shared/move-handle-icon/move-handle-icon';


interface IQuestionCardProps {
    updateQuestion: TUpdateQuestion;
    question: QuestionEntity;
    isDisabled: boolean;
    handleProps?: DraggableProvidedDragHandleProps;
    reviewModeAdditionalAction?: TReviewModeAdditionalAction;
    isSpecialActionButton?: boolean;
    isReviewMode?: boolean;
    setEditableQuestionState: (id: string | null, state: EditableState) => void;
}

const QuestionCard: FC<IQuestionCardProps> = observer(({
  updateQuestion,
  question,
  isDisabled,
  reviewModeAdditionalAction,
  isSpecialActionButton,
  isReviewMode,
  setEditableQuestionState
}): JSX.Element => {
  const [activeMessageId, setActiveMessageId] = useState<string | null>(null);

  const showEditButton = (question.senderStatus === SenderStatus.PRESENTER) || (question.aiResponse && question.senderStatus === SenderStatus.AI);
  return (
    <li
      className={classnames('qanda-question',
        { 'qanda-question--disabled': isDisabled && question.messageId === activeMessageId },
        { 'qanda-question--highlighted' : (question.isNew || question.isHighlighted) && !isDisabled }
      )}
    >
      <div className="question-upper">
        <div className="question-upper-top">
          <div className="question-upper-metadata">
            <p className="question-nick">

              <span className="unanswered-author">{question.senderName}</span>
              <span className="question-timestamp"> {getDate(question.sentDate)}</span>
              {showEditButton &&
                <span
                  className="edit-question"
                  data-has-action={!!reviewModeAdditionalAction}
                  onClick={() => setEditableQuestionState(question.messageId || null, EditableState.OPENED)}
                >Edit
                </span>}
            </p>
            <div className="question-email">{question.senderEmail}</div>
          </div>
          { question.isNew && (
            <span className='question-upper-label-new'>New</span>
          )}
        </div>
        {reviewModeAdditionalAction && (
          <div className="pos-next-btn">
            <ActionButton
              customClasses="next-icon"
              onClick={() => reviewModeAdditionalAction.additionalHandler(question.messageId, reviewModeAdditionalAction.stateType, setActiveMessageId)}
            />
          </div>)}
        {question.topic && <h3 className="question-topic">
          {question.topic}
        </h3>}
        <div className={question.topic ? 'question-title-with-topic' : 'question-title'}>
          {question.message}
        </div>
        <MoveHandleIcon/>
      </div>
      <div className="unanque_write-answer">
        <hr/>
        <div className="unanque_buttons">
          {isSpecialActionButton
            ? <ActionButton
              customClasses="remove-icon theme-red"
              onClick={() => reviewModeAdditionalAction?.additionalHandler(question.messageId, QuestionState.REMOVED, setActiveMessageId)}
              >
              Remove
            </ActionButton>
            : <QuestionActionButtons
              isReviewMode={isReviewMode}
              updateMessage={updateQuestion}
              isDisabled={isDisabled}
              messageId={question.messageId}
              stateType={question.state}
              setActiveMessageId={setActiveMessageId}
              />
          }
        </div>
      </div>
    </li>
  );
});

export default QuestionCard;
